import iconCalendar from "../../../assets/icons/ic-calendar.png";
import "./index.scss";
import React, { Component } from "react";
import moment from "moment";
import * as actions from "./../../../modules/user/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DoubleCalendar from "../../shared/double-calendar";
import request from "./../../../core/api";
import { CITY_BOOKING, MENU_TYPE_ALL } from "../../../constants/app";

moment.locale("ja");

class Content extends Component {
  constructor(props) {
    super(props);
    this.isCityBooking = this.props.user.shopDetail.city_name === CITY_BOOKING;
    this.listDiscount = this.props.user.shopDiscounts;
    this.dispatch = this.props.dispatchActions;
    this.mapDayLocale = [
      { jp: "月", en: "MON" },
      { jp: "火", en: "TUE" },
      { jp: "水", en: "WED" },
      { jp: "木", en: "THU" },
      { jp: "金", en: "FRI" },
      { jp: "土", en: "SAT" },
      { jp: "日", en: "SUN" },
    ];
    this.state = {
      shopId: props.match.params.id,
      dateRightCalendar: "",
      workingDays: props.user.shopDetail.workingHoursOfWeek.map(
        (item) => item.dayOfWeek
      ),
      dateLeftCalendar: "",
      chosenDate: "",
      chosenTime: "",
      timeBlocks: [],
      multiCalendarChosenDate: moment(),
      discountTime: {},
    };
  }

  getDefaultFirstDateCanChose = () => {
    let today = moment();
    let todayJp = moment(today).format("dd");
    let todayEn = this.mapDayLocale.find((item) => item.jp === todayJp).en;

    //eslint-disable-next-line
    while (!this.state.workingDays.find((item) => item === todayEn)) {
      today = moment(today).add(1, "day");
      todayJp = moment(today).format("dd");

      //eslint-disable-next-line
      todayEn = this.mapDayLocale.find((item) => item.jp === todayJp).en;
    }
    return today;
  };

  componentDidMount() {
    window.scrollTo(0, 0);

    const { isUserChosenTime, chosenTime } = this.props.user.userBookingData;
    const { getDefaultFirstDateCanChose, getListDiscountBySelectedDate } = this;
    if (!isUserChosenTime) {
      this.saveToLocalStorage({
        time: moment(chosenTime || getDefaultFirstDateCanChose()).set({
          hour: 0,
          minutes: 0,
          second: 0,
        }),
      });
    }

    this.setState(
      {
        multiCalendarChosenDate: moment(
          chosenTime || getDefaultFirstDateCanChose()
        ),
        discountList: getListDiscountBySelectedDate(),
      },
      () => {
        this.fetchAvailableBookTime(
          this.state.multiCalendarChosenDate.format("YYYY-MM-DD")
        ).then(({ data }) => {
          this.setState({
            timeBlocks: data.map((item) => {
              const time = moment(item).format("YYYY-MM-DD HH:mm");
              const discountByTime = this.initDiscountFromBlockTime(time);
              return {
                time: moment(item).format("HH:mm"),
                discount: discountByTime,
              };
            }),
          });
        });
      }
    );
  }

  componentDidUpdate(prevProps, prevStates) {
    if (
      !moment(this.state.multiCalendarChosenDate).isSame(
        prevStates.multiCalendarChosenDate,
        "day"
      )
    ) {
      const discountByDate = this.getListDiscountBySelectedDate();
      this.setState({
        listDiscount: discountByDate,
      });
      this.fetchAvailableBookTime(
        this.state.multiCalendarChosenDate.format("YYYY-MM-DD")
      ).then((result) => {
        const timeBlocks = result.data.map((item) => {
          const time = moment(item).format("YYYY-MM-DD HH:mm");
          const discountByTime = this.initDiscountFromBlockTime(time);
          return {
            time: moment(item).format("HH:mm"),
            discount: discountByTime,
          };
        });
        this.setState({
          timeBlocks,
        });
      });
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  fetchAvailableBookTime = (date) => {
    const { chosenStaff } = this.props.user.userBookingData;

    let params = {
      date,
      discount: true,
    };

    if (chosenStaff) {
      params.staff = chosenStaff;
    }

    return request({
      url: `shop/${this.state.shopId}/available/`,
      method: "get",
      params,
    });
  };

  initDiscountFromBlockTime = (time) => {
    const availableDiscount = this.listDiscount.filter((discount) => {
      return (
        moment(discount.valid_to).isAfter(time) &&
        discount.menu_type === MENU_TYPE_ALL
      );
    });

    if (!availableDiscount.length) return null;

    return availableDiscount[0];
  };

  disableDate = (date) => {
    const dayOfWeekJp = date.format("dd");
    const dayOfWeekEn = this.mapDayLocale.find(
      (item) => item.jp === dayOfWeekJp
    ).en;
    return !!!this.state.workingDays.find((item) => item === dayOfWeekEn);
  };

  saveToLocalStorage = (
    { time, discount, otherDiscount, timeDiscount },
    type
  ) => {
    const userBookingData = {
      ...this.props.user.userBookingData,
      chosenTime: time.format("YYYY-MM-DD HH:mm"),
      discount: discount || "",
      otherDiscount,
      timeDiscount,
    };

    if (type === 1) {
      userBookingData.isUserChosenTime = true;
    } else {
      userBookingData.isUserChosenTime = false;
    }

    this.dispatch.setUserBookingData({
      key: this.state.shopId,
      value: userBookingData,
    });
  };

  isValidDiscount = (discount, defaultTime) => {
    if (!discount || !discount.valid_from || !discount.valid_to) return false;
    const selectTimeStr = `${moment(this.state.multiCalendarChosenDate).format("YYYY-MM-DD")} ${defaultTime}`;
    const selectMoment = moment(selectTimeStr, "YYYY-MM-DD HH:mm");

    const validFrom = moment(discount.valid_from);
    const validTo = moment(discount.valid_to);

    const isDateInRange =
      selectMoment.isSameOrAfter(validFrom, "day") &&
      selectMoment.isSameOrBefore(validTo, "day");
    const isTimeInRange =
      selectMoment.format("HH:mm") >= validFrom.format("HH:mm") &&
      selectMoment.format("HH:mm") <= validTo.format("HH:mm");


    return isDateInRange && isTimeInRange;
  };

  renderDiscountValue = (discount, price) => {
    if (discount.type === "Percentage") {
      return (+discount.value * +price) / 100;
    } else {
      return +discount.value;
    }
  };

  choseTime = (item, discount) => {
    const time = item.time || item;
    const { chosenTime } = this.props.user.userBookingData;

    let listChosen = this.props.user.userBookingData.chosenMenu;
    let totalDiscount = "";
    let other = "";

    if (listChosen) {
      listChosen = this.props.user.userBookingData.chosenMenu.split(",");
      totalDiscount = listChosen
        .map((chosen) =>
          this.props.user.shopMenus.find((menu) => +chosen === menu.id)
        )
        .reduce((acc, curr) => {
          const discount = this.props.user.shopDiscounts.find(
            (item) => curr.discount === item.id
          );

          let amount = acc;
          if (this.isValidDiscount(discount, time)) {
            if (discount.type === "Other") {
              other = discount;
            } else {
              amount += this.renderDiscountValue(discount, time, curr.price);
            }
          }
          return amount;
        }, 0);
    }

    let dataSave = {
      time: moment(chosenTime).set({
        hour: time?.split(":")[0],
        minutes: time?.split(":")[1],
      }),
      discount: totalDiscount,
      otherDiscount: other,
    };
    if (discount) {
      dataSave["timeDiscount"] = discount;
    }

    this.saveToLocalStorage(dataSave, 1);

    this.props.history.push(`/${this.state.shopId}/booking/`);
  };

  gotoTop = () => {
    this.props.history.push(`/${this.state.shopId}/booking/`);
  };

  multiCalendarDisabledDate = (date) => {
    const isPast = moment(date.format("YYYY-MM-DD")).isBefore(
      moment().format("YYYY-MM-DD")
    );
    const dayOfWeekJp = date.format("dd");
    const dayOfWeekEn = this.mapDayLocale.find(
      (item) => item.jp === dayOfWeekJp
    ).en;
    return (
      !!!this.state.workingDays.find((item) => item === dayOfWeekEn) || isPast
    );
  };

  multiCalendarStyledDate = (date) => {
    let className = "";
    const SATURDAY = "SAT";
    const SUNDAY = "SUN";
    if (
      this.mapDayLocale.find((item) => item.jp === date.format("dd")).en ===
      SATURDAY
    ) {
      className = "regular-holiday--saturday";
    }
    if (
      this.mapDayLocale.find((item) => item.jp === date.format("dd")).en ===
      SUNDAY
    ) {
      className = "regular-holiday--sunday";
    }

    return className;
  };

  onMultiCalendarChoseDate = (date) => {
    let listChosen = this.props.user.userBookingData.chosenMenu;
    let totalDiscount = "";

    if (listChosen) {
      listChosen = this.props.user.userBookingData.chosenMenu.split(",");

      totalDiscount = listChosen
        .map((chosen) =>
          this.props.user.shopMenus.find((menu) => +chosen === menu.id)
        )
        .reduce((acc, curr) => {
          const discount = this.props.user.shopDiscounts.find(
            (item) => curr.discount === item.id
          );

          let amount = acc;

          if (
            discount &&
            moment(
              moment(discount.valid_to).format("YYYY-MM-DD HH:mm")
            ).isSameOrAfter(
              moment(
                moment(date).set({
                  hour: 0,
                  minutes: 0,
                })
              ).format("YYYY-MM-DD HH:mm")
            ) &&
            moment(
              moment(discount.valid_from).format("YYYY-MM-DD HH:mm")
            ).isSameOrBefore(
              moment(
                moment(date).set({
                  hour: 0,
                  minutes: 0,
                })
              ).format("YYYY-MM-DD HH:mm")
            )
          ) {
            if (discount.type === "Percentage") {
              amount += (+discount.value * +curr.price) / 100;
            } else {
              amount += +discount.value;
            }
          }
          return amount;
        }, 0);
    }
    this.saveToLocalStorage({
      time: moment(date).set({
        hour: 0,
        minutes: 0,
      }),
      discount: totalDiscount,
    });

    this.setState({ multiCalendarChosenDate: date });
  };

  renderDiscountElm = (discount) => {
    if (discount.type === "Other") return discount.value_other;
    return `${discount.value?.split(".")?.[0]} ${
      discount.type === "Fixed" ? "円" : "%"
    }`;
  };

  getDefaultDiscount = (time) => {
    const data = this.props.user.shopDiscounts.filter((item) => {
      const { start_block, end_block } = item;
      const format_valid_to = Number(end_block.replace(":", ""));
      const format_valid_from = Number(start_block.replace(":", ""));
      const format_time = Number(time.replace(":", ""));

      return (
        Number(format_valid_from) <= format_time &&
        Number(format_valid_to) > format_time
      );
    });

    return data.length ? data[0] : null;
  };

  getListDiscountBySelectedDate = () => {
    const date = this.state.multiCalendarChosenDate.format("YYYY-MM-DD");
    const availableDiscount = this.props.user.shopDiscounts?.filter((item) => {
      const isBefore = moment(item.valid_from).isBefore(date);
      const isAfter = moment(item.valid_to).isAfter(date);
      return isBefore && isAfter && item.menu_type === MENU_TYPE_ALL;
    });
    return availableDiscount || null;
  };

  getDefaultDiscount = (discount, time) => {
    if (!discount) return null;
    const data = discount.filter((item) => {
      const { start_block, end_block } = item;
      const format_valid_to = Number(end_block.replace(":", ""));
      const format_valid_from = Number(start_block.replace(":", ""));
      const format_time = Number(time.replace(":", ""));

      return (
        Number(format_valid_from) <= format_time &&
        Number(format_valid_to) > format_time
      );
    });

    return data.length ? data[0] : null;
  };

  render() {
    const { multiCalendarChosenDate, timeBlocks, listDiscount } = this.state;
    const {
      choseTime,
      gotoTop,
      multiCalendarDisabledDate,
      multiCalendarStyledDate,
      onMultiCalendarChoseDate,
      renderDiscountElm,
      getDefaultDiscount,
    } = this;
    const { chosenTime, isUserChosenTime } = this.props.user.userBookingData;

    return (
      <div
        id="user-booking-time"
        className="user-booking-time user-staffs fade-out"
      >
        <div className="user-booking-time__wrapper">
          <div className="user-staffs__ttl user-menus__ttl user-booking-time__ttl">
            <section>
              <figure>
                <img src={iconCalendar} alt="cippo-booking"></img>
              </figure>
              <p>日時選択</p>
            </section>
            <span className="user-menus__btn-return-top" onClick={gotoTop}>
              TOPへ戻る
            </span>
          </div>
          <div className="user-staffs__ctn-wrapper user-booking-time__ctn-wrapper">
            <DoubleCalendar
              className="user-booking-time__calendar"
              disabledDate={multiCalendarDisabledDate}
              styledDate={multiCalendarStyledDate}
              value={moment()}
              chosenDate={multiCalendarChosenDate}
              numberOfCalendar={2}
              onChoseDate={onMultiCalendarChoseDate}
            />
            <div className="user-booking-time__hint">
              <div>
                <span className="material-icons">crop_16_9</span>
                <p>当日</p>
              </div>
              <div>
                <span className="material-icons">crop_16_9</span>
                <p>選択した日付・時間</p>
              </div>
            </div>

            <div className="user-booking-time__block-times">
              <div className="selected-date">
                {moment(chosenTime).format("YYYY/MM/DD (dd)")}
              </div>
              <ul>
                {timeBlocks.map((item) => {
                  const isPrevDate = moment(
                    `${moment(chosenTime).format("YYYY-MM-DD")} ${item.time}`,
                    "YYYY-MM-DD HH:mm"
                  ).isBefore(moment());
                  const discount = this.isCityBooking
                    ? getDefaultDiscount(listDiscount, item.time || item)
                    : null;
                  return (
                    <button
                      className={
                        isUserChosenTime &&
                        item.time === moment(chosenTime).format("HH:mm")
                          ? "selected"
                          : ""
                      }
                      key={item.time}
                      disabled={isPrevDate && this.isCityBooking}
                      onClick={() => choseTime(item, discount)}
                    >
                      {item.time ?? item}
                      {this.isCityBooking && discount && (
                        <div className="mt-1">
                          {renderDiscountElm(discount)}
                        </div>
                      )}
                    </button>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchActions: bindActionCreators({ ...actions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Content);
